import React from 'react';
import _get from 'lodash/get';
import _has from 'lodash/has';

import { useTheme } from '@mui/styles';

import IPAddress from '../components/ipaddress';

import { ToFixed } from '../libraries/helpers';


const getEntity = (data, name) => {
    const d = _get(data, `_source.entity`, [])
    if (d.length) {
        const result = d.find(x => x.name === name);
        if (result && _has(result, 'value')) {
            return result.value;
        }
    }
    return 'N/A';
};

const getFeature = (data, name, expected) => {
    const d = _get(data, `_source.feature_data`, [])
    if (d.length) {
        const result = d.find(x => x.feature_name === name);
        if (result) {
            if (expected) {
                const id = result.feature_id;
                const ev = _get(data, '_source.expected_values[0].value_list', []);
                if (ev.length) {
                    const expectedValue = ev.find(x => x.feature_id === id);
                    return _get(expectedValue, 'data', 'N/A');
                }
            }
            return _get(result, 'data', 'N/A');
        }
    }
    return 'N/A';
};

const spanStyle = {
    lineHeight: '30px',
};

const ipStyle = {
    display: 'inline-block',
    verticalAlign: 'bottom',
};

export default {
    "unexpected-transfer-inbound-from-an-orig-to-a-resp": (d) => {
        const theme = useTheme();
        const origIP = getEntity(d, 'bro_log.id.orig_h');
        const respIP = getEntity(d, 'bro_log.id.resp_h');
        const numBytes = getFeature(d, 'resp_bytes');
        const numBytesExpected = getFeature(d, 'resp_bytes', true);
        return (<span style={spanStyle}>IP <IPAddress style={ipStyle} address={origIP} /> received <b style={{color: theme.palette.error.light}}>{ToFixed(numBytes, 2)}</b> bytes from <IPAddress style={ipStyle} address={respIP} /> in comparision to its expected transfer of <b style={{color: theme.palette.success.light}}>{ToFixed(numBytesExpected, 2)}</b> bytes.</span>);
    },
    "unexpected-transfer-outbound-from-an-orig-to-a-resp":  (d) => {
        const theme = useTheme();
        const origIP = getEntity(d, 'bro_log.id.orig_h');
        const respIP = getEntity(d, 'bro_log.id.resp_h');
        const numBytes = getFeature(d, 'orig_bytes');
        const numBytesExpected = getFeature(d, 'orig_bytes', true);
        return (<span style={spanStyle}>IP <IPAddress style={ipStyle} address={origIP} /> transmitted  <b style={{color: theme.palette.error.light}}>{ToFixed(numBytes, 2)}</b> bytes to <IPAddress style={ipStyle} address={respIP} /> in comparision to its expected transfer of <b style={{color: theme.palette.success.light}}>{ToFixed(numBytesExpected, 2)}</b> bytes.</span>);
    },
    "unusual-duration-for-a-resp":  (d) => {
        const theme = useTheme();
        const respIP = getEntity(d, 'bro_log.id.resp_h');
        const numMins = getFeature(d, 'duration');
        const numMinsExpected = getFeature(d, 'duration', true);
        return (<span style={spanStyle}>IP <IPAddress style={ipStyle} address={respIP} /> sustained a longer than usual connection of duration: <b style={{color: theme.palette.error.light}}>{ToFixed(numMins, 2)}</b> minutes in comparision to its expected duration: <b style={{color: theme.palette.success.light}}>{ToFixed(numMinsExpected, 2)}</b> minutes.</span>);
    },
    "unusual-duration-for-an-orig":  (d) => {
        const theme = useTheme();
        const origIP = getEntity(d, 'bro_log.id.orig_h');
        const numMins = getFeature(d, 'duration');
        const numMinsExpected = getFeature(d, 'duration', true);
        return (<span style={spanStyle}>IP <IPAddress style={ipStyle} address={origIP} /> sustained  a longer than usual connection of duration: <b style={{color: theme.palette.error.light}}>{ToFixed(numMins, 2)}</b> minutes in comparision to its expected duration: <b style={{color: theme.palette.success.light}}>{ToFixed(numMinsExpected, 2)}</b> minutes. </span>);
    },
    "unexpected-packet-count-from-an-orig-to-a-resp-inbound":  (d) => {
        const theme = useTheme();
        const origIP = getEntity(d, 'bro_log.id.orig_h');
        const respIP = getEntity(d, 'bro_log.id.resp_h');
        const numPackets = getFeature(d, 'resp_packets');
        const numPacketsExpected = getFeature(d, 'resp_packets', true);
        return (<span style={spanStyle}>IP <IPAddress style={ipStyle} address={origIP} /> received <b style={{color: theme.palette.error.light}}>{ToFixed(numPackets, 2)}</b> packets from <IPAddress style={ipStyle} address={respIP} /> in comparison to its expected count of <b style={{color: theme.palette.success.light}}>{ToFixed(numPacketsExpected, 2)}</b>.</span>);
    },
    "unexpected-packet-count-from-an-orig-to-a-resp-outbound": (d) => {
        const theme = useTheme();
        const origIP = getEntity(d, 'bro_log.id.orig_h');
        const respIP = getEntity(d, 'bro_log.id.resp_h');
        const numPackets = getFeature(d, 'orig-packets');
        const numPacketsExpected = getFeature(d, 'orig-packets', true);
        return (<span style={spanStyle}>IP <IPAddress style={ipStyle} address={origIP} /> transmitted <b style={{color: theme.palette.error.light}}>{ToFixed(numPackets, 2)}</b> packets to <IPAddress style={ipStyle} address={respIP} /> in comparison to its expected count of <b style={{color: theme.palette.success.light}}>{ToFixed(numPacketsExpected, 2)}</b>.</span>);
    },
    "excessive-authentication-spikes":  (d) => {
        const theme = useTheme();
        const origIP = getEntity(d, 'bro_log.id.orig_h');
        const username = getEntity(d, 'bro_log.username.keyword');
        return (<span style={spanStyle}>IP <IPAddress style={ipStyle} address={origIP} /> is attempting to authenticate to user: <b style={{color: theme.palette.error.light}}>{username}</b> more frequently than is typical.</span>);
    },
    "unexpected-country-in-outbound-connection-attempt":  (d) => {
        const theme = useTheme();
        const origIP = getEntity(d, 'bro_log.id.orig_h');
        const country = getEntity(d, 'bricata.dest_location.country.keyword');
        return (<span style={spanStyle}><IPAddress style={ipStyle} address={origIP} /> is attempting connection(s) to a host located in a country <b style={{color: theme.palette.error.light}}>{country}</b> which is unusual for this host.</span>);
    },
    "unexpected-protocol-usage-for-host":  (d) => {
        const theme = useTheme();
        const origIP = getEntity(d, 'bro_log.id.orig_h', true);
        const protocol = getEntity(d, 'bro_log.service.keyword', true);
        return (<span style={spanStyle}> <IPAddress style={ipStyle} address={origIP} /> was detected using protocol: <b style={{color: theme.palette.error.light}}>{protocol}</b>, which is unusual for this host.</span>);
    },
    "unexpected-connection-failures-inbound":  (d) => {
        const theme = useTheme();
        const origIP = getEntity(d, 'bro_log.id.orig_h');
        const respIP = getEntity(d, 'bro_log.id.resp_h');
        const connCount = getFeature(d, 'connection_count');
        const numPackets = getFeature(d, 'resp_pkts', true);
        const numBytes = getFeature(d, 'resp_bytes');
        return (<span style={spanStyle}> <IPAddress style={ipStyle} address={origIP} /> had <b style={{color: theme.palette.error.light}}>{connCount}</b> connection failures from host <IPAddress style={ipStyle} address={respIP} /> while transferring total <b>{ToFixed(numPackets, 2)}</b> packets with <b>{ToFixed(numBytes, 2)}</b> bytes.</span>);
    },
    "unexpected-connection-failures-outbound":  (d) => {
        const theme = useTheme();
        const origIP = getEntity(d, 'bro_log.id.orig_h');
        const respIP = getEntity(d, 'bro_log.id.resp_h');
        const connCount = getFeature(d, 'connection_count');
        const numPackets = getFeature(d, 'orig_pkts', true);
        const numBytes = getFeature(d, 'orig_bytes');
        return (<span style={spanStyle}><IPAddress style={ipStyle} address={origIP} /> had <b style={{color: theme.palette.error.light}}>{connCount}</b> connection failures from host <IPAddress style={ipStyle} address={respIP} /> while transferring total <b>{ToFixed(numPackets, 2)}</b> packets with <b>{ToFixed(numBytes, 2)}</b> bytes.</span>);
    },
}
